/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyNano = createReactComponent("currency-nano", "IconCurrencyNano", [
  ["path", { d: "M7 20l10 -16", key: "svg-0" }],
  ["path", { d: "M7 12h10", key: "svg-1" }],
  ["path", { d: "M7 16h10", key: "svg-2" }],
  ["path", { d: "M17 20l-10 -16", key: "svg-3" }]
]);

export { IconCurrencyNano as default };
//# sourceMappingURL=IconCurrencyNano.js.map
